/* eslint-disable no-shadow */

// initial state
const state = {
  campaignName: '',
  campaignId: null,
  value: null,
};

// getters
const getters = {
  getNewCampaignName(state) {
    return state.campaignName;
  },
  getNewCampaignId(state) {
    return state.campaignId;
  },
  getNewCampaignValue(state) {
    return state.value;
  },
};

// actions
const actions = {
  //
};

// mutations
const mutations = {
  saveCampaign(state, payload) {
    state.campaignName = payload.campaignName;
    state.campaignId = payload.campaignId;
    state.value = payload.value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
